import { A11yModule } from '@angular/cdk/a11y'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'
import { CookieService } from 'ngx-cookie-service'

import { AppComponent } from './app.component'
import { AppRoutingModule } from './app-routing.module'
import { BuyButtonComponent } from './components/buy-button/buy-button.component'
import { CompareToolBannerComponent } from './components/compare-tool/compare-tool-banner/compare-tool-banner.component'
import { CompareToolButtonComponent } from './components/compare-tool/compare-tool-button/compare-tool-button.component'
import { CompareToolCheckboxComponent } from './components/compare-tool/compare-tool-checkbox/compare-tool-checkbox.component'
import { AssetClassFilterComponent } from './components/filters/assetClassFilter/assetClassFilter.component'
import { FilterByComponent } from './components/filters/filterBy/filterBy.component'
import { FiltersComponent } from './components/filters/filters.component'
import { FiltersNVGComponent } from './components/filters/filters-nvg.component'
import { InvestmentMinimumFilterComponent } from './components/filters/investmentMinimumFilter/investmentMinimumFilter.component'
import { ManagementStyleFilterComponent } from './components/filters/managementStyleFilter/managementStyleFilter.component'
import { ProductTypeFilterComponent } from './components/filters/productTypeFilter/productTypeFilter.component'
import { RegionFilterComponent } from './components/filters/regionFilter/regionFilter.component'
import { RiskFilterComponent } from './components/filters/riskFilter/riskFilter.component'
import { ShareClassFilterComponent } from './components/filters/shareClassFilter/shareClassFilter.component'
import { StrategyFilterComponent } from './components/filters/strategyFilter/strategyFilter.component'
import { TaxEfficiencyFilterComponent } from './components/filters/tax-efficiency-filter/tax-efficiency-filter.component'
import { ListPageComponent } from './components/list-page/list-page.component'
import { ListPagination } from './components/list-pagination/list-pagination.component'
import { SortByComponent } from './components/sorting/sort-by/sort-by.component'
import { DetailViewComponent } from './components/tabs/detail-view/detail-view.component';
import { ResultsComponent } from './components/tabs/results/results.component'
import { ResultsComponentMobile } from './components/tabs/results/results.component.mobile'
import { AEMService } from './services/AEM/aem-content.service'
import { ApplicationStateService } from './services/application-state.service'
import { CentralContentService } from './services/content/central-content.service'
import { LoadingService } from './services/loading.service'
import { SeoService } from './services/seo/seo.service'
import { ScrollingTableDirective } from './utils/directives/scrolling-table.directive'
import { ESTPipe } from './utils/pipes/est.pipe'
import { NumberSuffixPipe } from './utils/pipes/number-suffix.pipe'
import { PercentParserPipe } from './utils/pipes/percent-parser.pipe'
import { SortByPipe } from './utils/pipes/sort-by.pipe'
import { YieldNoteParserPipe } from './utils/pipes/yield-note-parser.pipe'
import { NumberUtilsService } from './utils/services/NumberUtils.service';
export function retrieve_content(centralContentService: CentralContentService) {
  return () => centralContentService.load()
}
import { GlobalErrorHandlerService } from './services/global-error-handler.service'
import { SharedModule } from './shared/shared.module'

@NgModule({
  declarations: [
    AppComponent,
    ListPageComponent,
    ResultsComponent,
    ResultsComponentMobile,
    FiltersComponent,
    PercentParserPipe,
    YieldNoteParserPipe,
    ListPagination,
    CompareToolButtonComponent,
    CompareToolCheckboxComponent,
    FilterByComponent,
    RiskFilterComponent,
    AssetClassFilterComponent,
    ProductTypeFilterComponent,
    ManagementStyleFilterComponent,
    ShareClassFilterComponent,
    InvestmentMinimumFilterComponent,
    StrategyFilterComponent,
    ProductTypeFilterComponent,
    RegionFilterComponent,
    SortByComponent,
    SortByPipe,
    ESTPipe,
    BuyButtonComponent,
    TaxEfficiencyFilterComponent,
    CompareToolBannerComponent,
    DetailViewComponent,
    NumberSuffixPipe,
    ScrollingTableDirective,
    FiltersNVGComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    SharedModule,
    A11yModule,
  ],
  exports:[ScrollingTableDirective],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    NumberUtilsService,
    SortByPipe,
    ESTPipe,
    CookieService,
    ApplicationStateService,
    AEMService,
    SeoService,
    CentralContentService,
    LoadingService,
    {
      provide: APP_INITIALIZER,
      useFactory: retrieve_content,
      deps: [CentralContentService],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    }
  ],
})
export class AppModule {

}
